module.exports = __webpack_public_path__ + "img/EPriestAmen64_ua.e0674d45.webp";